import { forwardRef, ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectButton as SelectButtonBase } from 'prime-ng-old/selectbutton';
import { HttpClient } from '@angular/common/http';
import { createPlaceholderEntryItem } from '../utils';
import { INPUT_OPTIONS_DYNAMIC_HOST } from '../input-options-dynamic/supported_component';
import { ScreenService, UiScreenServiceModule } from '../screen-service';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { ObjectUtils } from 'prime-ng-old/utils';
import { InputRefBlockerDirective } from '../input-ref';
import { UiSpinnerComponent } from '../spinner';
import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../screen-service";
import * as i3 from "../input-ref/input-ref.directive";
import * as i4 from "../input-ref/form-control-name";
import * as i5 from "../input-dropdown/input-dropdown";
import * as i6 from "@angular/forms";
const _c0 = (a0, a1, a2) => ({
  "p-highlight": a0,
  "p-disabled": a1,
  "ui-button-icon-only": a2
});
const _c1 = (a0, a1) => ({
  $implicit: a0,
  index: a1
});
function UiInputSelectButtonComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner");
  }
}
function UiInputSelectButtonComponent_ng_template_1_div_0_div_2_ng_container_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
  }
  if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵclassMap(option_r3.icon);
    i0.ɵɵproperty("ngClass", "ui-button-icon ui-button-icon-left");
    i0.ɵɵattribute("data-pc-section", "icon");
  }
}
function UiInputSelectButtonComponent_ng_template_1_div_0_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, UiInputSelectButtonComponent_ng_template_1_div_0_div_2_ng_container_1_span_1_Template, 1, 4, "span", 10);
    i0.ɵɵelementStart(2, "span", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r3.icon);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r4.getOptionLabel(option_r3));
  }
}
function UiInputSelectButtonComponent_ng_template_1_div_0_div_2_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputSelectButtonComponent_ng_template_1_div_0_div_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputSelectButtonComponent_ng_template_1_div_0_div_2_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const option_r3 = ctx_r6.$implicit;
    const i_r4 = ctx_r6.index;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.selectButtonTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c1, option_r3, i_r4));
  }
}
function UiInputSelectButtonComponent_ng_template_1_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function UiInputSelectButtonComponent_ng_template_1_div_0_div_2_Template_div_click_0_listener($event) {
      const ctx_r1 = i0.ɵɵrestoreView(_r1);
      const option_r3 = ctx_r1.$implicit;
      const i_r4 = ctx_r1.index;
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.onOptionSelect($event, option_r3, i_r4));
    })("keydown", function UiInputSelectButtonComponent_ng_template_1_div_0_div_2_Template_div_keydown_0_listener($event) {
      const ctx_r5 = i0.ɵɵrestoreView(_r1);
      const option_r3 = ctx_r5.$implicit;
      const i_r4 = ctx_r5.index;
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.onKeyDown($event, option_r3, i_r4));
    })("focus", function UiInputSelectButtonComponent_ng_template_1_div_0_div_2_Template_div_focus_0_listener($event) {
      const i_r4 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.onFocus($event, i_r4));
    })("blur", function UiInputSelectButtonComponent_ng_template_1_div_0_div_2_Template_div_blur_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.onBlur());
    });
    i0.ɵɵtemplate(1, UiInputSelectButtonComponent_ng_template_1_div_0_div_2_ng_container_1_Template, 4, 3, "ng-container", 9)(2, UiInputSelectButtonComponent_ng_template_1_div_0_div_2_ng_template_2_Template, 1, 5, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const customcontent_r8 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(option_r3.styleClass + " " + (ctx_r4.isSelected(option_r3) ? ctx_r4.selectedButtonClass : ctx_r4.buttonClass));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(14, _c0, ctx_r4.isSelected(option_r3), ctx_r4.disabled || ctx_r4.isOptionDisabled(option_r3), option_r3.icon && !ctx_r4.getOptionLabel(option_r3)));
    i0.ɵɵattribute("tabindex", i_r4 === ctx_r4.focusedIndex ? "0" : "-1")("aria-label", option_r3.label)("role", ctx_r4.multiple ? "checkbox" : "radio")("aria-checked", ctx_r4.isSelected(option_r3))("aria-disabled", ctx_r4.optionDisabled)("aria-pressed", ctx_r4.isSelected(option_r3))("title", option_r3.title)("aria-labelledby", ctx_r4.getOptionLabel(option_r3))("data-pc-section", "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.itemTemplate)("ngIfElse", customcontent_r8);
  }
}
function UiInputSelectButtonComponent_ng_template_1_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6, 2);
    i0.ɵɵtemplate(2, UiInputSelectButtonComponent_ng_template_1_div_0_div_2_Template, 4, 18, "div", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r4.styleClass);
    i0.ɵɵproperty("ngClass", "p-selectbutton p-buttonset p-component")("ngStyle", ctx_r4.style);
    i0.ɵɵattribute("aria-labelledby", ctx_r4.ariaLabelledBy)("data-pc-name", "selectbutton")("data-pc-section", "root");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.options);
  }
}
function UiInputSelectButtonComponent_ng_template_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-input-dropdown", 14);
    i0.ɵɵpipe(1, "filterOutPlaceholderItem");
    i0.ɵɵlistener("ngModelChange", function UiInputSelectButtonComponent_ng_template_1_ng_template_1_Template_ui_input_dropdown_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.onItemClickMobileView($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("options", i0.ɵɵpipeBind1(1, 7, ctx_r4._options))("optionValue", ctx_r4.optionValue)("optionLabel", ctx_r4.optionLabel)("dataKey", ctx_r4.dataKey)("optionDisabled", ctx_r4.optionDisabled)("disabled", ctx_r4.disabled)("ngModel", ctx_r4.value);
  }
}
function UiInputSelectButtonComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputSelectButtonComponent_ng_template_1_div_0_Template, 3, 8, "div", 5)(1, UiInputSelectButtonComponent_ng_template_1_ng_template_1_Template, 2, 9, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const compactLayout_r10 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r4.useMobileLayout)("ngIfElse", compactLayout_r10);
  }
}
function UiInputYesNoSelectButtonComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner");
  }
}
function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_ng_container_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
  }
  if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵclassMap(option_r3.icon);
    i0.ɵɵproperty("ngClass", "ui-button-icon ui-button-icon-left");
    i0.ɵɵattribute("data-pc-section", "icon");
  }
}
function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_ng_container_1_span_1_Template, 1, 4, "span", 10);
    i0.ɵɵelementStart(2, "span", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r3.icon);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r4.getOptionLabel(option_r3));
  }
}
function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const option_r3 = ctx_r6.$implicit;
    const i_r4 = ctx_r6.index;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.selectButtonTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c1, option_r3, i_r4));
  }
}
function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_Template_div_click_0_listener($event) {
      const ctx_r1 = i0.ɵɵrestoreView(_r1);
      const option_r3 = ctx_r1.$implicit;
      const i_r4 = ctx_r1.index;
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.onOptionSelect($event, option_r3, i_r4));
    })("keydown", function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_Template_div_keydown_0_listener($event) {
      const ctx_r5 = i0.ɵɵrestoreView(_r1);
      const option_r3 = ctx_r5.$implicit;
      const i_r4 = ctx_r5.index;
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.onKeyDown($event, option_r3, i_r4));
    })("focus", function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_Template_div_focus_0_listener($event) {
      const i_r4 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.onFocus($event, i_r4));
    })("blur", function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_Template_div_blur_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.onBlur());
    });
    i0.ɵɵtemplate(1, UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_ng_container_1_Template, 4, 3, "ng-container", 9)(2, UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_ng_template_2_Template, 1, 5, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const customcontent_r8 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(option_r3.styleClass + " " + (ctx_r4.isSelected(option_r3) ? ctx_r4.selectedButtonClass : ctx_r4.buttonClass));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(14, _c0, ctx_r4.isSelected(option_r3), ctx_r4.disabled || ctx_r4.isOptionDisabled(option_r3), option_r3.icon && !ctx_r4.getOptionLabel(option_r3)));
    i0.ɵɵattribute("tabindex", i_r4 === ctx_r4.focusedIndex ? "0" : "-1")("aria-label", option_r3.label)("role", ctx_r4.multiple ? "checkbox" : "radio")("aria-checked", ctx_r4.isSelected(option_r3))("aria-disabled", ctx_r4.optionDisabled)("aria-pressed", ctx_r4.isSelected(option_r3))("title", option_r3.title)("aria-labelledby", ctx_r4.getOptionLabel(option_r3))("data-pc-section", "button");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.itemTemplate)("ngIfElse", customcontent_r8);
  }
}
function UiInputYesNoSelectButtonComponent_ng_template_1_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6, 2);
    i0.ɵɵtemplate(2, UiInputYesNoSelectButtonComponent_ng_template_1_div_0_div_2_Template, 4, 18, "div", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r4.styleClass);
    i0.ɵɵproperty("ngClass", "p-selectbutton p-buttonset p-component")("ngStyle", ctx_r4.style);
    i0.ɵɵattribute("aria-labelledby", ctx_r4.ariaLabelledBy)("data-pc-name", "selectbutton")("data-pc-section", "root");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.options);
  }
}
function UiInputYesNoSelectButtonComponent_ng_template_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-input-dropdown", 14);
    i0.ɵɵpipe(1, "filterOutPlaceholderItem");
    i0.ɵɵlistener("ngModelChange", function UiInputYesNoSelectButtonComponent_ng_template_1_ng_template_1_Template_ui_input_dropdown_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.onItemClickMobileView($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("options", i0.ɵɵpipeBind1(1, 7, ctx_r4._options))("optionValue", ctx_r4.optionValue)("optionLabel", ctx_r4.optionLabel)("dataKey", ctx_r4.dataKey)("optionDisabled", ctx_r4.optionDisabled)("disabled", ctx_r4.disabled)("ngModel", ctx_r4.value);
  }
}
function UiInputYesNoSelectButtonComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputYesNoSelectButtonComponent_ng_template_1_div_0_Template, 3, 8, "div", 5)(1, UiInputYesNoSelectButtonComponent_ng_template_1_ng_template_1_Template, 2, 9, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const compactLayout_r10 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r4.useMobileLayout)("ngIfElse", compactLayout_r10);
  }
}
const _c2 = "[_nghost-%COMP%]{--borderLeftRadius:var(--buttonBorderRadius);--borderRightRadius:var(--buttonBorderRadius);--blr:var(--borderLeftRadius);--brr:var(--borderRightRadius)}.rounded[_nghost-%COMP%]{--borderLeftRadius:var(--roundedButtonBorderRadius);--borderRightRadius:var(--roundedButtonBorderRadius)}.p-selectbutton[_ngcontent-%COMP%]     .ui-button{border-radius:0}.p-selectbutton[_ngcontent-%COMP%]     .ui-button.small{height:var(--inputHeight)}.p-selectbutton[_ngcontent-%COMP%]     .ui-button .ui-button-content{padding:var(--inputPadding)}.p-selectbutton[_ngcontent-%COMP%]     .ui-button+.ui-button{margin-left:calc(-1 * var(--buttonBorderWidth))}.p-selectbutton[_ngcontent-%COMP%]     .ui-button+.ui-button-outline{margin-left:calc(-1 * var(--buttonOutlineBorderWidth))}.p-selectbutton[_ngcontent-%COMP%]     .ui-button:first-child{border-top-left-radius:var(--blr);border-bottom-left-radius:var(--blr)}.p-selectbutton[_ngcontent-%COMP%]     .ui-button:last-child{border-top-right-radius:var(--brr);border-bottom-right-radius:var(--brr)}[_nghost-%COMP%] > ui-input-dropdown[_ngcontent-%COMP%]{--borderLeftRadius:var(--blr);--borderRightRadius:var(--brr);display:flex;flex:1}";
export const SELECTBUTTON_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UiInputSelectButtonComponent),
  multi: true
};
export const YESNO_SELECTBUTTON_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UiInputYesNoSelectButtonComponent),
  multi: true
};
export let FilterOutPlaceholderItemPipe = /*#__PURE__*/(() => {
  class FilterOutPlaceholderItemPipe {
    transform(options) {
      console.log('filterOutPlaceholderItem');
      if (!Array.isArray(options)) return options;
      return options.filter(opt => opt?.isPlaceholder !== true);
    }
    static {
      this.ɵfac = function FilterOutPlaceholderItemPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FilterOutPlaceholderItemPipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "filterOutPlaceholderItem",
        type: FilterOutPlaceholderItemPipe,
        pure: true
      });
    }
  }
  return FilterOutPlaceholderItemPipe;
})();
// p-button -> ui-button class (also for p-button-icon p-button-icon-left p-button-icon-only p-button-label)
// .ui-button-label -> add .ui-button-content
// add *ngIf="!useMobileLayout; else compactLayout" to .p-selectbutton
// add #compactLayout section
// add custom classes to .ui-button: (isSelected(option) ? ' '+selectedButtonClass : ''+buttonClass)
// wrap everything in <ng-template #main>
// add <ng-template [ngIf]="loading"> section
// todo: should use real uiButton component
const TEMPLATE = `
	<ng-template [ngIf]="loading" [ngIfElse]="main">
	<ui-spinner></ui-spinner>
</ng-template>

<ng-template #main>
	<div #container [ngClass]="'p-selectbutton p-buttonset p-component'" [ngStyle]="style" [class]="styleClass" role="group" [attr.aria-labelledby]="ariaLabelledBy" [attr.data-pc-name]="'selectbutton'" [attr.data-pc-section]="'root'" *ngIf="!useMobileLayout; else compactLayout">
		<div
			*ngFor="let option of options; let i = index"
			pRipple
			[attr.tabindex]="i === focusedIndex ? '0' : '-1'"
			[attr.aria-label]="option.label"
			[attr.role]="multiple ? 'checkbox' : 'radio'"
			[attr.aria-checked]="isSelected(option)"
			[attr.aria-disabled]="optionDisabled"
			class="ui-button p-component"
			[class]="option.styleClass + ' ' + (isSelected(option) ? selectedButtonClass : buttonClass)"
			[ngClass]="{ 'p-highlight': isSelected(option), 'p-disabled': disabled || isOptionDisabled(option), 'ui-button-icon-only': option.icon && !getOptionLabel(option) }"
			[attr.aria-pressed]="isSelected(option)"
			(click)="onOptionSelect($event, option, i)"
			(keydown)="onKeyDown($event, option, i)"
			[attr.title]="option.title"
			(focus)="onFocus($event, i)"
			(blur)="onBlur()"
			[attr.aria-labelledby]="this.getOptionLabel(option)"
			[attr.data-pc-section]="'button'"
		>
			<ng-container *ngIf="!itemTemplate; else customcontent">
				<span [ngClass]="'ui-button-icon ui-button-icon-left'" [class]="option.icon" *ngIf="option.icon" [attr.data-pc-section]="'icon'"></span>
				<span class="ui-button-label ui-button-content" [attr.data-pc-section]="'label'">{{ getOptionLabel(option) }}</span>
			</ng-container>
			<ng-template #customcontent>
				<ng-container *ngTemplateOutlet="selectButtonTemplate; context: { $implicit: option, index: i }"></ng-container>
			</ng-template>
		</div>
	</div>
	<ng-template #compactLayout>
		<ui-input-dropdown 
			inputRefBlocker
			[options]="_options | filterOutPlaceholderItem" 
			[optionValue]="optionValue" 
			[optionLabel]="optionLabel" 
			[dataKey]="dataKey" 
			[optionDisabled]="optionDisabled" 
			[disabled]="disabled"
			[ngModel]="value" 
			(ngModelChange)="onItemClickMobileView($event)"
		></ui-input-dropdown>
	</ng-template>
</ng-template>
`;
export let UiInputSelectButtonComponent = /*#__PURE__*/(() => {
  class UiInputSelectButtonComponent extends SelectButtonBase {
    constructor(cd, http, screen) {
      super(cd);
      this.http = http;
      this.screen = screen;
      this.destroyRef = inject(DestroyRef);
      this.dataKey = null; // data key is used to work with objects as values
      this.small = true;
      this.deselectable = false;
      this.rounded = false;
      this.breakpoint = 500;
      this.useMobileLayout = false;
      this.buttonClass = 'ui-button-grey';
      this.selectedButtonClass = 'ui-button-primary';
      this.loading = false;
      this.onItemClickMobileView = value => {
        const option = this.options.find(opt => ObjectUtils.equals(value, this.getOptionValue(opt), this.dataKey));
        if (this.disabled || this.isOptionDisabled(option)) {
          return;
        }
        // if (this.multiple) {
        //     if (this.isSelected(option))
        //         this.removeOption(option);
        //     else
        //         this.value = [...(this.value||[]), this.getOptionValue(option)];
        // }
        // else {
        this.value = this.getOptionValue(option);
        // }
        // this.onOptionClick.emit({
        //     originalEvent: event,
        //     option: option,
        //     index: index
        // });
        this.onModelChange(this.value);
        this.onChange.emit({
          originalEvent: null,
          value: this.value
        });
      };
      this.overrideProperties();
    }
    ngOnInit() {
      if (this.breakpoint > 0) {
        this.screen.windowWidth$.pipe(takeWhileAlive(this.destroyRef)).subscribe(val => {
          this.useMobileLayout = val <= this.breakpoint;
          this.cd.detectChanges();
          this.cd.markForCheck();
        });
      }
    }
    isSelected(option) {
      if (option?.isPlaceholder) {
        // placeholder item value is set to "null".
        // but we also want the item to be active if value is "undefined"
        // so we need to tweak the matching a bit.
        if (this.value === null || this.value === undefined) return true;
      }
      return super.isSelected(option);
    }
    markForCheck() {
      this.cd.markForCheck();
    }
    overrideProperties() {
      Object.defineProperty(this, "options", {
        get() {
          return this._options;
        },
        set(val) {
          const hasNoOptions = !Array.isArray(val) || val.length === 0;
          if (hasNoOptions) {
            this._options = [createPlaceholderEntryItem('Keine Optionen verfügbar', this.optionLabel, this.optionValue)];
          } else {
            const opts = val;
            if (this.deselectable) opts.unshift(createPlaceholderEntryItem('Keine', this.optionLabel, this.optionValue));
            this._options = opts;
          }
          this.cd.markForCheck();
        }
      });
    }
    static {
      this.ɵfac = function UiInputSelectButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiInputSelectButtonComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.HttpClient), i0.ɵɵdirectiveInject(i2.ScreenService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiInputSelectButtonComponent,
        selectors: [["ui-input-selectbutton"]],
        hostVars: 4,
        hostBindings: function UiInputSelectButtonComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("rounded", ctx.rounded)("mobile-layout", ctx.useMobileLayout);
          }
        },
        inputs: {
          dataKey: "dataKey",
          small: "small",
          deselectable: "deselectable",
          rounded: "rounded",
          breakpoint: "breakpoint",
          buttonClass: "buttonClass",
          selectedButtonClass: "selectedButtonClass"
        },
        features: [i0.ɵɵProvidersFeature([SELECTBUTTON_VALUE_ACCESSOR, {
          provide: INPUT_OPTIONS_DYNAMIC_HOST,
          useExisting: forwardRef(() => UiInputSelectButtonComponent)
        }]), i0.ɵɵHostDirectivesFeature([i3.InputRefDirective, {
          directive: i4.FormControlNameStandalone,
          inputs: ["formControlName", "formControlNameStandalone"]
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 2,
        consts: [["main", ""], ["compactLayout", ""], ["container", ""], ["customcontent", ""], [3, "ngIf", "ngIfElse"], ["role", "group", 3, "ngClass", "ngStyle", "class", 4, "ngIf", "ngIfElse"], ["role", "group", 3, "ngClass", "ngStyle"], ["pRipple", "", "class", "ui-button p-component", 3, "class", "ngClass", "click", "keydown", "focus", "blur", 4, "ngFor", "ngForOf"], ["pRipple", "", 1, "ui-button", "p-component", 3, "click", "keydown", "focus", "blur", "ngClass"], [4, "ngIf", "ngIfElse"], [3, "ngClass", "class", 4, "ngIf"], [1, "ui-button-label", "ui-button-content"], [3, "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["inputRefBlocker", "", 3, "ngModelChange", "options", "optionValue", "optionLabel", "dataKey", "optionDisabled", "disabled", "ngModel"]],
        template: function UiInputSelectButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, UiInputSelectButtonComponent_ng_template_0_Template, 1, 0, "ng-template", 4)(1, UiInputSelectButtonComponent_ng_template_1_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const main_r11 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.loading)("ngIfElse", main_r11);
          }
        },
        dependencies: [i5.UiInputDropdownComponent, FormsModule, i6.NgControlStatus, i6.NgModel, UiScreenServiceModule, UiSpinnerComponent, InputRefBlockerDirective, NgClass, NgStyle, NgIf, NgFor, FilterOutPlaceholderItemPipe],
        styles: [_c2],
        changeDetection: 0
      });
    }
  }
  return UiInputSelectButtonComponent;
})();
export let UiInputYesNoSelectButtonComponent = /*#__PURE__*/(() => {
  class UiInputYesNoSelectButtonComponent extends UiInputSelectButtonComponent {
    constructor() {
      super(...arguments);
      this._options = [{
        value: false,
        label: 'Nein'
      }, {
        value: true,
        label: 'Ja'
      }];
      this.breakpoint = -1;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiInputYesNoSelectButtonComponent_BaseFactory;
        return function UiInputYesNoSelectButtonComponent_Factory(__ngFactoryType__) {
          return (ɵUiInputYesNoSelectButtonComponent_BaseFactory || (ɵUiInputYesNoSelectButtonComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiInputYesNoSelectButtonComponent)))(__ngFactoryType__ || UiInputYesNoSelectButtonComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiInputYesNoSelectButtonComponent,
        selectors: [["ui-input-yesno-selectbutton"]],
        inputs: {
          _options: "_options",
          breakpoint: "breakpoint"
        },
        features: [i0.ɵɵProvidersFeature([YESNO_SELECTBUTTON_VALUE_ACCESSOR]), i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 2,
        consts: [["main", ""], ["compactLayout", ""], ["container", ""], ["customcontent", ""], [3, "ngIf", "ngIfElse"], ["role", "group", 3, "ngClass", "ngStyle", "class", 4, "ngIf", "ngIfElse"], ["role", "group", 3, "ngClass", "ngStyle"], ["pRipple", "", "class", "ui-button p-component", 3, "class", "ngClass", "click", "keydown", "focus", "blur", 4, "ngFor", "ngForOf"], ["pRipple", "", 1, "ui-button", "p-component", 3, "click", "keydown", "focus", "blur", "ngClass"], [4, "ngIf", "ngIfElse"], [3, "ngClass", "class", 4, "ngIf"], [1, "ui-button-label", "ui-button-content"], [3, "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["inputRefBlocker", "", 3, "ngModelChange", "options", "optionValue", "optionLabel", "dataKey", "optionDisabled", "disabled", "ngModel"]],
        template: function UiInputYesNoSelectButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, UiInputYesNoSelectButtonComponent_ng_template_0_Template, 1, 0, "ng-template", 4)(1, UiInputYesNoSelectButtonComponent_ng_template_1_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const main_r11 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.loading)("ngIfElse", main_r11);
          }
        },
        dependencies: [i5.UiInputDropdownComponent, FormsModule, i6.NgControlStatus, i6.NgModel, UiScreenServiceModule, UiSpinnerComponent, InputRefBlockerDirective, FilterOutPlaceholderItemPipe],
        styles: [_c2],
        changeDetection: 0
      });
    }
  }
  return UiInputYesNoSelectButtonComponent;
})();